/**
 * What: Resolves the TestFeed house illustration URLs used by Shopify onboarding, empty, and plan surfaces.
 * Transport / data-flow: Vite asset imports resolved at build time; no fetching, state, or merchant data.
 *
 */
import preparedSetups from '../../assets/welcome-hero-pointing.webp'
import planPrompt from '../../assets/pricing-shopkeeper.webp'
import capabilityPending from '../../assets/empty-state-inspector.png'
import supportContact from '../../assets/millie.webp'
import connectAccount from '../../assets/setup-connect-account.webp'
import choosePlan from '../../assets/setup-choose-plan.webp'
import syncIntelligence from '../../assets/setup-sync-intelligence.webp'
import heroImage from '../../assets/welcome-ab-test.png'

/** Keeps illustration sourcing in one module so a surface never hot-links the marketing site. */
export const houseImagery = {
  preparedSetups,
  planPrompt,
  capabilityPending,
  supportContact,
  connectAccount,
  choosePlan,
  syncIntelligence,
  heroImage,
} as const
